import { type FC } from 'react'
import { TrialTimeline } from '../../Common/TrialTimeline'
import { type DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const AnalyticsTimeline: FC<DeltaTrialTimelineProps> = (props) => {
  return <TrialTimeline featureName='Analytics' {...props} />
}
